import {
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    PRODUCT_DELETE_REQUEST,
    PRODUCT_DELETE_SUCCESS,
    PRODUCT_DELETE_FAIL,
    PRODUCT_CREATE_REQUEST,
    PRODUCT_CREATE_FAIL,
    PRODUCT_CREATE_SUCCESS,
    PRODUCT_CREATE_RESET,
    PRODUCT_UPDATE_REQUEST,
    PRODUCT_UPDATE_SUCCESS,
    PRODUCT_UPDATE_FAIL,
    PRODUCT_UPDATE_RESET,
    PRODUCT_CREATE_REVIEW_REQUEST,
    PRODUCT_CREATE_REVIEW_SUCCESS,
    PRODUCT_CREATE_REVIEW_FAIL,
    PRODUCT_CREATE_REVIEW_RESET,
    SHOW_DELETE_MODAL,
    HIDE_DELETE_MODAL,
    SHOW_CREATE_MODAL,
    HIDE_CREATE_MODAL,
    SHOW_UPDATE_MODAL,
    HIDE_UPDATE_MODAL,
    PRODUCTS_ALL_REQUEST,
    PRODUCTS_ALL_SUCCESS,
    PRODUCTS_ALL_FAIL,
} from '../constants/productConstants'
export const productListReducer = (state={products: { docs: [], allProducts: [] } },action) => {
    switch(action.type) {
        case PRODUCT_LIST_REQUEST :
            return {loading : true, products : {docs: []}}
        case PRODUCT_LIST_SUCCESS :
            return {loading : false , products: action.payload}
        case PRODUCT_LIST_FAIL :
            return {loading : false , error : action.payload}
        default :
        return state  
        }
}

export const productsAllReducer = (state={ allProducts: {}, loading: false },action) => {
    switch(action.type) {
        case PRODUCTS_ALL_REQUEST :
            return {loading : true, allProducts : { }}
        case PRODUCTS_ALL_SUCCESS :
            return {loading : false , allProducts: action.payload}
        case PRODUCTS_ALL_FAIL :
            return {loading : false , error : action.payload}
        default :
        return state  
    }
}

export const productDetailsReducer = (
    state={product : {reviews : [], images : [] , category : [],sizes : []} },action) => {
    switch(action.type) {
        case PRODUCT_DETAILS_REQUEST :
            return {loading : true, ...state}
        case PRODUCT_DETAILS_SUCCESS :
            return {loading : false , product: action.payload}
        case PRODUCT_DETAILS_FAIL :
            return {loading : false , error : action.payload}
        default :
        return state  
        }
}

export const productDeleteReducer = (
    state={modalDelete: false, selectedItem: {}},action) => {
    switch(action.type) {
        case PRODUCT_DELETE_REQUEST :
            return {loading : true}
        case PRODUCT_DELETE_SUCCESS :
            return {
                loading : false , 
                success: true,
                modalDelete: false,
                selectedItem: {},
            }
        case PRODUCT_DELETE_FAIL :
            return {loading : false , error : action.payload}
        case SHOW_DELETE_MODAL:
            return {modalDelete: true, selectedItem: action.payload}
        case HIDE_DELETE_MODAL :
            return {modalDelete: false, selectedItem: {}}
        default :
        return state  
        }
} 

export const productCreateReducer = (
    state={modalCreate: false},action) => {
    switch(action.type) {
        case PRODUCT_CREATE_REQUEST :
            return {loading : true}
        case PRODUCT_CREATE_SUCCESS :
            return {loading : false ,success : true, product: action.payload}
        case PRODUCT_CREATE_FAIL :
            return {loading : false , error : action.payload}
        case PRODUCT_CREATE_RESET :
            return {}
        case SHOW_CREATE_MODAL:
            return {modalCreate: true}
        case HIDE_CREATE_MODAL :
            return {modalCreate: false}
        default :
        return state  
        }
} 
export const productUpdateReducer = (
    state={product : {}, updateModal: false},action) => {
    switch(action.type) {
        case PRODUCT_UPDATE_REQUEST :
            return {loading : true}
        case PRODUCT_UPDATE_SUCCESS :
            return {loading : false ,success : true, product: action.payload}
        case PRODUCT_UPDATE_FAIL :
            return {loading : false , error : action.payload}
        case PRODUCT_UPDATE_RESET :
            return {product : {}}
        case SHOW_UPDATE_MODAL:
            return {updateModal: true, product: action.payload}
        case HIDE_UPDATE_MODAL :
            return {updateModal: false, product: {}}
        default :
        return state  
        }
} 

export const productreviewCreateReducer = (
    state={},action) => {
    switch(action.type) {
        case PRODUCT_CREATE_REVIEW_REQUEST :
            return {loading : true}
        case PRODUCT_CREATE_REVIEW_SUCCESS :
            return {loading : false ,success : true}
        case PRODUCT_CREATE_REVIEW_FAIL :
            return {loading : false , error : action.payload}
        case PRODUCT_CREATE_REVIEW_RESET :
            return {}
        default :
        return state  
        }
} 